import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { fixtureContext } from "../context/FixtureContext";

import Textarea from "@mui/joy/Textarea";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import useLoginfo from "../../utils/useLoginfo";

const EditPlanogram = () => {
  const {
    submitAssortmentPlanogramAction,
    getSinglePlanogramAction,
    planoSingleRow,
  } = useContext(fixtureContext);

  const history = useHistory()
  //OKTA
  const { tokenVal } = useLoginfo()

  const { planoID } = useParams();

  useEffect(() => {

    getSinglePlanogramAction({
      f: planoID.split("-")[0],
      i: planoID.split("-")[1],
      j: planoID.split("-")[2],
    }, tokenVal);

  }, [tokenVal]);

  const [formData, setFormData] = useState({
    FIXTURE_NUMBER: "",
    CATEGORY_NAME: "",
    SUB_CATEGORY_NAME: "",
    PLANO_NBR: "",
    PLANO_NAME: "",
    SERIAL_NUM: "",
    ACTIVE: "",
    ADMIN_ONLY: "",
    START_DATE: "",
    END_DATE: "",
    LEAD_TIME: "",
    FIXED_TIME: "",
    MAX_SHIP_DATE: "",
    MIN_SHIP_DATE: "",
    ASSORTMENT_NBR: "",
    DEPARTMENT: "",
    MARKDOWN: "",
    DATING: "",
    AVAILABILITY: "",
    LAST_CHANCE: "",
    ASSORTMENT_NAME: ""
  });

  useEffect(() => {
    // console.log(planoSingleRow);
    let end = new Date(planoSingleRow[0]?.END_DATE).getMonth() + 1;
    let start = new Date(planoSingleRow[0]?.START_DATE).getMonth() + 1;
    let maxi = new Date(planoSingleRow[0]?.END_DATE).getMonth() + 1;
    let mini = new Date(planoSingleRow[0]?.START_DATE).getMonth() + 1;

    setFormData({
      FIXTURE_NUMBER: planoSingleRow[0]?.FIXTURE_NUMBER,
      ASSORTMENT_NBR: planoSingleRow[0]?.ASSORTMENT_NBR,
      ACTIVE: planoSingleRow[0]?.ACTIVE,
      ADMIN_ONLY: planoSingleRow[0]?.ADMIN_ONLY,
      SERIAL_NUM: planoSingleRow[0]?.SERIAL_NUM,
      START_DATE:
        new Date(planoSingleRow[0]?.START_DATE).getFullYear() +
        "-" +
        (start < 10 ? "0" + start : start) +
        "-" +
        (new Date(planoSingleRow[0]?.START_DATE).getDate() < 10
          ? "0" + new Date(planoSingleRow[0]?.START_DATE).getDate()
          : new Date(planoSingleRow[0]?.START_DATE).getDate()),
      END_DATE:
        new Date(planoSingleRow[0]?.END_DATE).getFullYear() +
        "-" +
        (end < 10 ? "0" + end : end) +
        "-" +
        (new Date(planoSingleRow[0]?.END_DATE).getDate() < 10
          ? "0" + new Date(planoSingleRow[0]?.END_DATE).getDate()
          : new Date(planoSingleRow[0]?.END_DATE).getDate()),
      PLANO_NAME: planoSingleRow[0]?.PLANO_NAME,
      PLANO_NBR: planoSingleRow[0]?.PLANO_NBR,
      FIXED_TIME: planoSingleRow[0]?.FIXED_TIME,
      LEAD_TIME: planoSingleRow[0]?.LEAD_TIME,
      MAX_SHIP_DATE:
        new Date(planoSingleRow[0]?.MAX_SHIP_DATE).getFullYear() +
        "-" +
        (maxi < 10 ? "0" + maxi : maxi) +
        "-" +
        (new Date(planoSingleRow[0]?.MAX_SHIP_DATE).getDate() < 10
          ? "0" + new Date(planoSingleRow[0]?.MAX_SHIP_DATE).getDate()
          : new Date(planoSingleRow[0]?.MAX_SHIP_DATE).getDate()),
      MIN_SHIP_DATE:
        new Date(planoSingleRow[0]?.MIN_SHIP_DATE).getFullYear() +
        "-" +
        (mini < 10 ? "0" + mini : mini) +
        "-" +
        (new Date(planoSingleRow[0]?.MIN_SHIP_DATE).getDate() < 10
          ? "0" + new Date(planoSingleRow[0]?.MIN_SHIP_DATE).getDate()
          : new Date(planoSingleRow[0]?.MIN_SHIP_DATE).getDate()),
      CATEGORY_NAME: planoSingleRow[0]?.CATEGORY_NAME,
      SUB_CATEGORY_NAME: planoSingleRow[0]?.SUB_CATEGORY_NAME,
      DEPARTMENT: planoSingleRow[0]?.DEPARTMENT,
      MARKDOWN: planoSingleRow[0]?.MARKDOWN,
      DATING: planoSingleRow[0]?.DATING,
      AVAILABILITY: planoSingleRow[0]?.AVAILABILITY,
      LAST_CHANCE: planoSingleRow[0]?.LAST_CHANCE,
      ASSORTMENT_NAME: planoSingleRow[0]?.ASSORTMENT_DESC,
    });
  }, [planoSingleRow]);

  //handle form change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [flag, setflag] = useState(false);
  //handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    //update row
    if (flag) {
      let daydiff =
        (new Date(formData.END_DATE).getTime() -
          new Date(formData.START_DATE).getTime()) /
        (1000 * 60 * 60 * 24);

      let daydiffship =
        (new Date(formData.MAX_SHIP_DATE).getTime() -
          new Date(formData.MIN_SHIP_DATE).getTime()) /
        (1000 * 60 * 60 * 24);

      let daydiffend =
        (new Date(formData.END_DATE).getTime() -
          new Date(formData.MAX_SHIP_DATE).getTime()) /
        (1000 * 60 * 60 * 24);

      let daydiffstart =
        (new Date(formData.MIN_SHIP_DATE).getTime() -
          new Date(formData.START_DATE).getTime()) /
        (1000 * 60 * 60 * 24);

      if (new Date(formData.MIN_SHIP_DATE).getFullYear().toString().length != 4)
        alert("Min Ship Date is invalid");
      else if (new Date(formData.MAX_SHIP_DATE).getFullYear().toString().length != 4)
        alert("Max Ship Date is invalid");
      else if (new Date(formData.START_DATE).getFullYear().toString().length != 4)
        alert("Start Date is invalid");
      else if (new Date(formData.END_DATE).getFullYear().toString().length != 4)
        alert("End Date is invalid");
      else if (daydiffship <= 0) alert("Max Ship Date should be after Min Ship Date");
      else if (daydiff <= 0) alert("End Date should be after Start Date");
      else if (daydiffend <= 0)
        alert("End Date should be after Max Ship Date");
      // else if (daydiffstart <= 0)
      //   alert("Start Date should be before Min Ship Date");
      else {
        submitAssortmentPlanogramAction([{ ...formData }], tokenVal, history);
        // history.push("/view-planogram");
      }
    }
  };

  //handle form cancel
  const handleCancel = (e) => {
    window.location.href = "/view-planogram";
  };

  return (
    <div>
      <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        style={{ marginLeft: "15px" }}
      >
        <Link underline="hover" color="inherit" href="/view-planogram">
          View Assortment Planogram
        </Link>
        <Link
          underline="hover"
          color="text.primary"
          href={`/edit-planogram/${planoID.split("-")[0]}-${planoID.split("-")[1]
            }-${planoID.split("-")[2]}`}
          aria-current="page"
        >
          Edit Assortment Planogram Form
        </Link>
      </Breadcrumbs>

      <h2 style={{ textAlign: "center" }}>Edit Assortment Planogram Form</h2>

      <form className="flex-container" onSubmit={handleSubmit}>
        <div style={{ marginLeft: "15px" }}>
          <div className="flex-container">
            <label className="">Admin Only</label>
            <TextField
              size="small"
              required={flag}
              name="ADMIN_ONLY"
              value={formData.ADMIN_ONLY}
              onChange={handleChange}
              className="depart"
              id="outlined-select-admin"
              select
            >
              <MenuItem key="Y" value="Y">
                Y
              </MenuItem>
              <MenuItem key="N" value="N">
                N
              </MenuItem>
            </TextField>
          </div>

          <div className="flex-container">
            <label className="">Min Ship Date</label>
            <TextField
              required={flag}
              name="MIN_SHIP_DATE"
              value={formData.MIN_SHIP_DATE}
              onChange={handleChange}
              id="min-date"
              type="date"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Max Ship Date</label>
            <TextField
              size="small"
              required={flag}
              name="MAX_SHIP_DATE"
              value={formData.MAX_SHIP_DATE}
              onChange={handleChange}
              id="max-date"
              type="date"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label>Sub Category Name</label>
            <Textarea
              minRows={2}
              variant="outlined"
              required={flag}
              name="SUB_CATEGORY_NAME"
              value={formData.SUB_CATEGORY_NAME}
              onChange={handleChange}
              type="text"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Active</label>
            <TextField
              size="small"
              required={flag}
              name="ACTIVE"
              value={formData.ACTIVE}
              onChange={handleChange}
              className="depart"
              id="outlined-select-active"
              select
            >
              <MenuItem key="Y" value="Y">
                Y
              </MenuItem>
              <MenuItem key="N" value="N">
                N
              </MenuItem>
            </TextField>
          </div>

          <div className="flex-container">
            <label className="">POG Number</label>
            <TextField
              size="small"
              required={flag}
              name="PLANO_NBR"
              value={formData.PLANO_NBR}
              onChange={handleChange}
              type="text"
              id="outlined-mark"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">POG Name</label>
            <Textarea
              minRows={2}
              variant="outlined"
              required={flag}
              name="PLANO_NAME"
              value={formData.PLANO_NAME}
              onChange={handleChange}
              type="text"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Fixed Time</label>
            <TextField
              size="small"
              required={flag}
              name="FIXED_TIME"
              value={formData.FIXED_TIME}
              onChange={handleChange}
              type="text"
              id="outlined-fixed"
              className="depart"
            />
          </div>
        </div>

        <div style={{ marginTop: "-35px", marginLeft: "15px" }}>
          <div className="flex-container">
            <label>Category Name</label>
            <Textarea
              minRows={2}
              variant="outlined"
              required={flag}
              name="CATEGORY_NAME"
              value={formData.CATEGORY_NAME}
              onChange={handleChange}
              type="text"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Assortment Number</label>
            <TextField
              size="small"
              required={true}
              className="depart"
              name="ASSORTMENT_NBR"
              value={formData.ASSORTMENT_NBR}
              onChange={handleChange}
              type="text"
              id="outlined-nbr"
            />
          </div>

          <div className="flex-container">
            <label className="">Fixture Assortment</label>
            <TextField
              size="small"
              required={flag}
              name="FIXTURE_NUMBER"
              value={formData.FIXTURE_NUMBER}
              onChange={handleChange}
              type="text"
              id="outlined-fixture"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Start Date</label>
            <TextField
              size="small"
              required={flag}
              name="START_DATE"
              value={formData.START_DATE}
              onChange={handleChange}
              id="start-date"
              type="date"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">End Date</label>
            <TextField
              size="small"
              required={flag}
              name="END_DATE"
              value={formData.END_DATE}
              onChange={handleChange}
              id="end-date"
              type="date"
              className="depart"
            />
          </div>

          <div className="flex-container">
            <label className="">Serial</label>
            <TextField
              size="small"
              required={true}
              className="depart"
              name="SERIAL_NUM"
              value={formData.SERIAL_NUM}
              onChange={handleChange}
              type="text"
              id="outlined-lead"
            />
          </div>

          <div className="flex-container">
            <label className="">Lead Time</label>
            <TextField
              size="small"
              required={true}
              className="depart"
              name="LEAD_TIME"
              value={formData.LEAD_TIME}
              onChange={handleChange}
              type="text"
              id="outlined-lead"
            />
          </div>

          <div className="" style={{ marginTop: "60px", display: "flex" }}>
            <div className="save-btn">
              <Button
                type="submit"
                variant="contained"
                color="success"
                onClick={(e) => setflag(true)}
                size="large"
              >
                <span className="cat-radio">Save</span>
              </Button>
            </div>
            <div>
              <Button
                className="cancel-btn"
                variant="contained"
                color="error"
                onClick={handleCancel}
                size="large"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
        <div className="search-btn"></div>
      </form>
    </div>
  );
};

export default EditPlanogram;
